import type { User } from '@xpanse/ui';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { AuthService } from 'src/utils/api';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constants';

const getUser = async (): Promise<User> => {
  const response = await AuthService.getUserId();
  return response;
};

export function useGetUser(isAuthTokenSet: boolean) {
  const { data: user, refetch } = useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  useEffect(() => {
    if (user && user.id) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ID, user.id);
    }
  }, [user]);

  return { user, refetchUserId: refetch };
}
